module.exports = __webpack_public_path__ + "assets/b8bc557ed9831511ab25efff2cd13d21.png";